import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {AdminService} from '../../shared/service/admin.service';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService, AuthenticationStore, BaseComponent, ConfirmationService, NotificationService} from '@enerbim/commons-lib';
import {LoginDialogService} from 'app/shared/service/login-dialog.service';
import {distinctUntilChanged, map, startWith, switchMap} from 'rxjs/operators';
import {combineLatest, Observable, of} from 'rxjs';
import {HeaderViewModel} from 'app/shared/model/view-model/header-view-model';
import {BimElementService} from '../../shared/service/bim-element.service';
import {BimElementUtils} from 'app/shared/utils/bim-element.utils';
import {BimElement} from 'app/shared/model/bim-element';
import {NavigationPath} from 'app/shared/model/navigation-path';
import {NavigationStore} from 'app/shared/store/navigation.store';
import {BimElementStore} from 'app/shared/store/bim-element.store';
import {NavigationService} from 'app/shared/service/navigation.service';

@Component({
    selector: 'bim-header',
    templateUrl: './header.component.html',
    styleUrls: ['header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent extends BaseComponent implements OnInit {

    viewModel$: Observable<HeaderViewModel>;
    breadcrumb$: Observable<NavigationPath[]>;

    constructor(
        private dialog: MatDialog,
        private authenticationService: AuthenticationService,
        private authenticationStore: AuthenticationStore,
        private loginModalService: LoginDialogService,
        private navigationStore: NavigationStore,
        private navigationService: NavigationService,
        private router: Router,
        private adminService: AdminService,
        private notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        private bimElementService: BimElementService,
        private bimElementStore: BimElementStore,
    ) {
        super();
    }

    ngOnInit() {
        this.breadcrumb$ = this.navigationStore.getPath();
        this.viewModel$ = combineLatest([
            this.authenticationStore.getCurrentUser(),
            this.bimElementStore.getCurrentElement().pipe(
                startWith(null),
            ),
            this.bimElementStore.getCurrentElement().pipe(
                startWith(null),
                map(currentElement => ({
                    currentElement,
                    idParc: BimElementUtils.getSelfOrParentId(currentElement, 'PARC')
                })),
                distinctUntilChanged((a, b) => a.idParc === b.idParc),
                switchMap(currentElementAndIdParc => {
                    const currentElement = currentElementAndIdParc.currentElement;
                    const idParc = currentElementAndIdParc.idParc;
                    let parc$: Observable<BimElement>;
                    if (currentElement && currentElement.typeElement == 'PARC') {
                        parc$ = of(currentElement);
                    } else if (currentElement) {
                        parc$ = this.bimElementService.elementBasicNoError(idParc);
                    } else {
                        parc$ = of(null);
                    }
                    return parc$;
                }),
            ),
        ]).pipe(
            map(([currentUser, currentElement, parc]) => {
                return {
                    currentUser,
                    isSuperadmin: currentUser ? currentUser.authorities.includes('ROLE_ADMIN') : null,
                    isDeveloper: currentUser ? currentUser.authorities.includes('ROLE_DEVELOPER') : null,
                    isAdminParc: (currentElement && parc) ? parc.role == 'ADMINISTRATEUR' : false,
                    idParc: (currentElement && parc) ? parc.id : null,
                    userImageUrl: currentUser ? currentUser.imageUrl : null
                } as HeaderViewModel;
            })
        );
    }

    login() {
        this.loginModalService.open();
    }

    logout() {
        this.authenticationService.logout().subscribe(() => {
            this.router.navigate(['']);
        });
    }

    navigate(element) {
        this.navigationService.navigate(element);
    }

    exportReferentiel() {
        this.adminService.exportReferentiel();
    }

    forceDataRefresh() {
        this.confirmationService.confirm('Êtes-vous sûr de vouloir lancer le rafraichissement des données serveur ?', () => {
            this.adminService.forceDataRefresh(() => {
                this.notificationService.success('Le rafraichissement des données a bien été effectué.');
            });
            this.notificationService.success('Le rafraichissement des données a bien été lancé.');
        });
    }

    goToLink(url: string) {
        window.open(url, "_blank");
    }
}
